const autocompleteModalDocCompany = {
  documentTypes: 'Document Type',
  document: 'Document',
};

export default autocompleteModalDocCompany;
